
import {

	Points,
	MeshBasicMaterial
	
} from 'three'

import EVENTS from '../globals/eventslist'

import Emitter from '../emitter'

let occlusionmaterial = new MeshBasicMaterial({color: 0x000000, fog: false, side: 2});

export default class OcclusionMeshPoint extends Points {

    constructor(geo, mat) {

    	super(geo, mat)

    	this.originalmaterial = mat

        this.occlusionEvent = this.onOcclusion.bind(this)

        this._addEvents()

    }

    onOcclusion(val){

    	this.material = val ? 
    		((this.originalmaterial.occlusionMaterial) ? this.originalmaterial.occlusionMaterial : occlusionmaterial) : this.originalmaterial
    }

    _addEvents(){

        Emitter.on(EVENTS.occlusion, this.occlusionEvent )
    }

    _removeEvents(){

    	Emitter.off(EVENTS.occlusion, this.occlusionEvent )

    }

	destroy(){

		this._removeEvents()
	}

}



// WEBPACK FOOTER //
// ./src/scripts/Trail/abstract/occlusionmeshpoint.js